const checkProjectStatus = (statusType, projectStatus) => {
  if (statusType === "CURRENT") {
    return (
      [
        "OPPORTUNITY",
        "PROJECT_PLANNING",
        "CONSTRUCTION",
        "PROMOTION_AND_OPERATIONS",
      ].findIndex((status) => status === projectStatus) >= 0
    )
  }
  if (statusType === "PAST") return projectStatus === "EXITED"
  return statusType === projectStatus
}

const filterProjects = (searchFilters, projects) => {
  const { projectType, propertyType, statusType } = searchFilters
  return projects.filter((project) => {
    return (
      (propertyType.value === project.primaryPropertyTag ||
        propertyType.value === "ALL_TYPES") &&
      (projectType.value === project.projectTag ||
        projectType.value === "ALL_TYPES") &&
      (checkProjectStatus(statusType.value, project.overview.status) ||
        statusType.value === "ALL_TYPES")
    )
  })
}

export default filterProjects
